import ENV_PROD from './env.production';
import ENV_LOCAL from './env.local';
import ENV_PREPROD from './env.preprod';

// APP_ENV is only set (to 'preprod') by the preprod webpack build, independent
// of __DEV__/mode -- that build also runs with mode=development (same as
// local dev-server), so __DEV__ alone can't tell preprod and local dev apart.
const ENV =
  process.env.APP_ENV === 'preprod'
    ? ENV_PREPROD
    : __DEV__
      ? ENV_LOCAL
      : ENV_PROD;

export default ENV;
